// extracted by mini-css-extract-plugin
export var features = "styles-module__features___a83Pr";
export var head = "styles-module__head___qNkY5";
export var feature = "styles-module__feature___f7BNQ";
export var newBadge = "styles-module__newBadge___bereG";